import { useEffect, useState } from "react";
import { Loader2, Smartphone } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const DevicesSection = () => {
  const [code, setCode] = useState(null);
  const [devices, setDevices] = useState([]);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/devices").then((r) => setDevices(r.data.devices)).catch(() => {});
  useEffect(() => { load(); }, []);
  const getCode = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/devices/pair-code");
      setCode(data.code);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  const revoke = async () => {
    try {
      await api.delete("/devices");
      setDevices([]);
      toast.success("All phones disconnected.");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <section className="panel p-6 sm:p-8 space-y-4" data-testid="settings-devices">
      <h2 className="text-lg font-semibold flex items-center gap-2"><Smartphone className="h-5 w-5" />Connect the Android app</h2>
      <p className="text-sm text-muted-foreground">Open the RizzAura Android app and enter this 6-digit code. It works once and expires in 10 minutes.</p>
      {code && <div data-testid="pair-code" translate="no" className="notranslate font-display text-4xl font-extrabold tracking-[0.3em]">{code}</div>}
      <button data-testid="pair-code-button" onClick={getCode} disabled={busy} className="h-10 px-5 rounded-full brand-gradient text-white text-sm font-semibold inline-flex items-center gap-2 disabled:opacity-40">
        {busy && <Loader2 className="h-4 w-4 animate-spin" />}{code ? "Get a new code" : "Get pairing code"}
      </button>
      {devices.length > 0 && (
        <div className="space-y-2" data-testid="paired-devices">
          <ul className="text-sm space-y-1">{devices.map((d, i) => <li key={i}>{d.name} · paired {new Date(d.paired_at).toLocaleDateString()}</li>)}</ul>
          <button data-testid="revoke-devices-button" onClick={revoke} className="text-sm text-rose-400 font-semibold">Disconnect all phones</button>
        </div>
      )}
    </section>
  );
};
